export interface PlanCheckTrackerTemplateList {
    id: number;
    logo: string;
    color_code: string;
    name: string;
}

// Single object mapping
export const mapPlanCheckTrackerTemplate = (data: any): PlanCheckTrackerTemplateList => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: PlanCheckTrackerTemplateList = {
        id: data.id,
        logo: data.logo,
        color_code: data.color_code,
        name: data.name,
    };

    return res;
};

// List mapping
export const mapPlanCheckTrackerTemplates = (data: any[]): PlanCheckTrackerTemplateList[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapPlanCheckTrackerTemplate);
};

// fils

export interface PlanCheckTrackerItemFileList {
    id?: number;
    plan_check_id?: number;
    item_id?: number;
    path?: string;
    file_upload_date?: string;
    extension?: string;
}

// Single object mapping
export const mapPlanCheckTrackerItemFile = (data: any): PlanCheckTrackerItemFileList => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: PlanCheckTrackerItemFileList = {
        id: data.id,
        plan_check_id: data.plan_check_id,
        item_id: data.item_id,
        path: data.path,
        file_upload_date: data.file_upload_date,
        extension: data.extension,
    };

    return res;
};

// List mapping
export const mapPlanCheckTrackerItemFiles = (data: any[]): PlanCheckTrackerItemFileList[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapPlanCheckTrackerItemFile);
};

// Assuming PlanCheckTrackerItemFileList and mapPlanCheckTrackerItemFiles are already defined

export interface PlanCheckTrackerItemList {
    id?: number;
    check_type?: "Basic" | "Detail";
    folder_id?: number;
    plan_check_part_id?: number | null;
    item_code?: string;
    comment?: string;
    status?: "Open" | "Closed";
    architect_response?: string | null;
    building_inspector_response?: string | null;
    file_list?: PlanCheckTrackerItemFileList[];
}

// Single object mapping
export const mapPlanCheckTrackerItem = (data: any): PlanCheckTrackerItemList => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: PlanCheckTrackerItemList = {
        id: data.id,
        check_type: data.check_type,
        folder_id: data.folder_id,
        plan_check_part_id: data.plan_check_part_id,
        item_code: data.item_code,
        comment: data.comment,
        status: data.status,
        architect_response: data.response_architect,
        building_inspector_response: data.response_building_inspector,
        file_list: Array.isArray(data.file_list)
            ? mapPlanCheckTrackerItemFiles(data.file_list)
            : [],
    };

    return res;
};

// List mapping
export const mapPlanCheckTrackerItems = (data: any[]): PlanCheckTrackerItemList[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapPlanCheckTrackerItem);
};

export interface PlanCheckTrackerPart {
    id?: number;
    folder_id?: number;
    part_number?: string;
    part_title?: string;
    total_item_count?: number;
    close_answer_count?: number;
    status?: "Open" | "Closed" | null;
    item_list?: PlanCheckTrackerItemList[];
}

// Single object mapping
export const mapPlanCheckTrackerPart = (data: any): PlanCheckTrackerPart => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: PlanCheckTrackerPart = {
        id: data.id,
        folder_id: data.folder_id,
        part_number: data.part_number,
        part_title: data.part_title,
        total_item_count: data.total_item_count,
        close_answer_count: data.close_answer_count,
        status: data.status,
        item_list: Array.isArray(data.item_list)
            ? mapPlanCheckTrackerItems(data.item_list)
            : [],
    };

    return res;
};

// List mapping
export const mapPlanCheckTrackerParts = (data: any[]): PlanCheckTrackerPart[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapPlanCheckTrackerPart);
};

export interface PlanCheckTracker {
    id?: number;
    type?: "Plan check" | "Plan check tracker";
    folder_id?: number;
    stage?: string;
    stage_for?: "Original" | "Response";
    date?: string;
    check_type?: "Basic" | "Detail";
    is_published_by_bi?: 1 | 0;
    is_sign_report_by_bi?: 1 | 0;
    sign_by_bi?: string | null;
    sign_date_by_bi?: string | null;
    is_published_by_arc?: 1 | 0;
    is_sign_report_by_arc?: 1 | 0;
    sign_by_arc?: string | null;
    sign_date_by_arc?: string | null;
    is_created_responce?: 1 | null;
    file_download_path?: string | null;
    inspector_name?: string;
    plan_check_part?: PlanCheckTrackerPart[];
    item_list?: PlanCheckTrackerItemList[];
}

// Single object mapping
export const mapPlanCheckTracker = (data: any): PlanCheckTracker => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: PlanCheckTracker = {
        id: data.id,
        type: data.type,
        folder_id: data.folder_id,
        stage: data.stage,
        stage_for: data.stage_for,
        date: data.date,
        check_type: data.check_type,
        is_published_by_bi: data.is_published_by_bi,
        is_sign_report_by_bi: data.is_sign_report_by_bi,
        sign_by_bi: data.sign_by_bi,
        sign_date_by_bi: data.sign_date_by_bi,
        is_published_by_arc: data.is_published_by_arc,
        is_sign_report_by_arc: data.is_sign_report_by_arc,
        sign_by_arc: data.sign_by_arc,
        sign_date_by_arc: data.sign_date_by_arc,
        is_created_responce: data.is_created_responce,
        file_download_path: data.file_download_path,
        inspector_name: data.inspector_name,
        plan_check_part: Array.isArray(data.plan_check_part)
            ? mapPlanCheckTrackerParts(data.plan_check_part)
            : [],
        item_list: Array.isArray(data.item_list)
            ? mapPlanCheckTrackerItems(data.item_list)
            : [],
    };

    return res;
};

// List mapping
export const mapPlanCheckTrackers = (data: any[]): PlanCheckTracker[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapPlanCheckTracker);
};
